import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Equalizer } from '../ui/Equalizer';
import { spring } from '../../utils/motion';
export function PlayfulBreak() {
  const [playing, setPlaying] = useState(false);
  return <section aria-labelledby="break-title" className="px-3 lg:px-5" data-id="element-396" data-mp="3s69m2c6z5ljq">
      <div className="mx-auto flex min-h-[60vh] max-w-6xl flex-col items-center justify-center rounded-lg bg-tint px-6 py-20 text-center lg:rounded-xl" data-id="element-397" data-mp="3n7q22hbxyju0">
        <motion.button type="button" onClick={() => setPlaying(p => !p)} aria-pressed={playing} aria-label={playing ? 'Stop the beat' : 'Play the beat'} whileHover={{
        scale: 1.04
      }} whileTap={{
        scale: 0.94
      }} transition={spring.snappy} className="grid h-28 w-28 place-items-center rounded-full bg-brand text-on-brand focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-ink/30" data-id="element-398" data-mp="3i7bu0zacb9vz">
          <Equalizer playing={playing} bars={5} className="h-12 gap-1.5" barClassName="w-2" data-id="element-399" data-mp="12gftui0ntl51" />
        </motion.button>
        <p className="mt-3 text-sm font-bold text-brand-strong" data-id="element-400" data-mp="25u6a0vsnjpy4">{playing ? 'Tap to stop' : 'Tap me'}</p>
        <h2 id="break-title" className="mt-8 max-w-[14ch] text-[40px] font-bold leading-[1.02] tracking-[-0.02em] text-ink lg:text-[80px]" data-id="element-401" data-mp="1vtm8rt54ulfw">
          Every gig starts with a yes.
        </h2>
      </div>
    </section>;
}